<template>
  <div>
    <el-col :span="24">
      <div>
        <div class="search-content">
          <el-col :span="24" class="toobar">
            <el-col :span="24">
            <el-col :span="3" >
              <el-select v-model="minyear" placeholder="" style="width:80px" size="mini">
                <el-option
                  v-for="item in getYearList()"
                  :key="item+''"
                  :label="item+''"
                  :value="item+''">
                </el-option>
              </el-select>
              <el-select v-model="minmonth" placeholder="" style="width:65px" size="mini">
                <el-option
                  v-for="item in monthList"
                  :key="item+''"
                  :label="item+''"
                  :value="item+''">
                </el-option>
              </el-select>
            </el-col>
            <el-col :span="3">
              <CommonTree :treeWidth="250" :treeHeight="300" :inputSize="'mini'"
                          ref="treeGroupSeed" :defineDataSource="true" @bindData="bindTreeData"
                          @afterBindTree="afterBindTree"
                          :onlyShowGroupType="true"
                          @check="checktree1" :canDelete="false"
                          :needTopNode="false"
                          placeholder="请选择类别">
              </CommonTree>
            </el-col>
            <el-col :span="8">
              <el-input placeholder="输入品牌名称" v-model="search.categoryname" size="mini" v-if="showCat" clearable style="width: 120px"></el-input>
              <el-input placeholder="输入商品名称" v-model="search.seedname" size="mini" v-if="!showCat" clearable style="width: 120px"></el-input>
              <el-input placeholder="输入型号" v-model="search.model" size="mini" v-if="!showCat" clearable style="width: 120px"></el-input>
              <el-input placeholder="输入规格" v-model="search.color" size="mini" v-if="!showCat" clearable style="width: 120px"></el-input>
            </el-col>
            <el-col :span="10">&nbsp;
              <el-button type="primary" icon="el-icon-search" @click="bindGrid" size="mini">搜索</el-button>
              <el-button type="success" icon="el-icon-upload" @click="findglassFrame" size="mini" v-if="islaox">找镜架</el-button>
              <el-button icon="el-icon-printer" @click="printBar" size="mini" v-if="!bimanage">打印条码</el-button>
              <el-button icon="el-icon-download" v-on:click="excelPort" size="mini">导出</el-button>
              <el-button icon="el-icon-download" v-on:click="excelStoreSale" v-if="isXiaoT" size="mini">半年销量</el-button>
            </el-col>
            </el-col>
            <el-col :span="3" style="text-align: center">
              <el-checkbox :indeterminate="isIndeterminate" v-model="checkAll" @change="handleCheckAllChange">全选</el-checkbox>
            </el-col>
            <el-col :span="20">
              <el-checkbox-group v-model="checkedCangkus" @change="handleCheckedCitiesChange">
                <el-checkbox v-for="item in jxcstoreData" :label="item.cangkucode" :key="item.cangkucode">{{item.cangkuname}}</el-checkbox>
              </el-checkbox-group>
            </el-col>
          </el-col>
        </div>
        <div v-if="!afterSearch" style="font-size: x-large;color: #ff6600;">请选择完查询条件后，点击“搜索”按钮</div>
        <el-table
          :data="tableData.filter(data =>
          (data.categoryname||data.seedname)&&(!search.categoryname || (data.categoryname&&data.categoryname.toLowerCase().includes(search.categoryname.toLowerCase())))&&
          (!search.seedname || (data.seedname&&data.seedname.toLowerCase().includes(search.seedname.toLowerCase())))&&
          (!search.model||(data.model&&data.model.toLowerCase().includes(search.model.toLowerCase())))&&
          (!search.color||(data.color&&data.color.toLowerCase().includes(search.color.toLowerCase())))
          )"
          :height="eltableheight"
          size="mini"
          :summary-method="getSummaries"
          show-summary
          border
          style="width: 100%;">
          <el-table-column
            width="60"
            label="序号"
            align="center">
            <template slot-scope="scope">
              {{1+scope.$index}}
            </template>
          </el-table-column>
          <el-table-column v-for="item in column" :key="item.value" :label="item.name" :show-overflow-tooltip="true"
                           :align="item.align" header-align="center"
                           :width="item.width" :prop="item.value">
            <template slot-scope="scope">
              <div v-if="item.align=='left'">{{ scope.row[item.value] }}</div>
              <div v-else>{{ scope.row[item.value]== 0 ? "":scope.row[item.value] }}</div>
            </template>
          </el-table-column>
          <el-table-column label="操作" header-align="center" align="left" width="120">
            <template slot-scope="scope">
              <el-button
                size="mini" v-if="scope.row.cangkucode!='all'"
                @click="handleEdit(scope.$index, scope.row)">查看
              </el-button>
            </template>
          </el-table-column>
        </el-table>
      </div>
    </el-col>
    <StorageFrameView ref="DataContactView"></StorageFrameView>
    <Findframe ref="Findframe1"></Findframe>
    <Storeprintbarcode ref="printbarcode"></Storeprintbarcode>
    <StorageFrameDetail ref="StorageFrameDetail1"></StorageFrameDetail>
    <BuyorderDetailEdit ref="BuyorderDetailEdit" @bindGrid="bindGrid()"></BuyorderDetailEdit>
    <AllocationEditNew ref="DataContactEdit2" @bindGrid="bindGrid"></AllocationEditNew>
    <UniqueCode ref="UniqueCode"></UniqueCode>

  </div>
</template>
<script>

  import {getGoodsTree} from '@/api/set/jxcgooddetail';
  import {isLaoxian,isXiaoTuan} from '@/api/login';
  import {getFramelistwithstore} from '@/api/set/jxcresultstore';
  import {getListDataall,frameStore} from '@/api/set/jxcstore';
  import StorageFrameView from './StorageFrameView';
  import StorageFrameDetail from './StorageFrameDetail';
  import Storeprintbarcode from './Storeprintbarcode';
  import Findframe from './Findframe';
  import BuyorderDetailEdit from '@/components/testorder/buyagreement/BuyorderDetailEdit';
  import AllocationEditNew from '@/components/warehouse/AllocationEditNew';
  import UniqueCode from '@/components/testorder/warehouse/UniqueCode';

  export default {

    name: 'StorageFrame',
    data() {

      let yearnow = new Date().getFullYear()
      let monthnow = new Date().getMonth() + 1
      return {
        afterSearch: false,
        islaox:false,
        isXiaoT:false,
        bimanage:false,
        userInfoModel: {},
        msg: 'Welcome to Your Vue.js App',
        addVisible: false,
        dialogFormVisible: false,
        eltableheight: 300,
        searchdata: "",
        search:{categoryname:'',seedname:'',model:'',color:''},
        showCat:false,
        checkedCangkus:[],
        cangkucode: "",
        jxcstoreData: [],
        minyear: yearnow,
        minmonth: monthnow,
        maxyear: yearnow,
        maxmonth: monthnow,
        yearflag: '',
        loading: true,
        status: "",
        seedcode: "",
        seedname: "",
        iscsshow: '',
        year: '',
        guids: "",
        isdeliverShow: true,
        isIndeterminate:false,
        checkAll:false,
        allOptions:[],
        gu: "",
        monthList: [1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12],//月份
        column:[],
        pagination: {
          currentPage: 1,
          pageSize: 0,
          total: 0,
        },
        tableData: [],
        timer:null,
        oldtableData: [],//备份tableData
      }
    },
    props: {
      mystatus: {
        default: '200'
      },
      roletype: {
        default: "" //角色菜单信息， 取值：order 、 buy、 store、machining、jiesuan、customerservice ， 分别对应订单、采购单、库存、加工、结算、客服 等菜单角色
      }
    },
    methods: {
      handleCheckAllChange(val) {
        this.checkedCangkus = val ? this.allOptions : [];
        this.isIndeterminate = false;
      },
      handleCheckedCitiesChange(value) {
        let checkedCount = value.length;
        this.checkAll = checkedCount === this.jxcstoreData.length;
        this.isIndeterminate = checkedCount > 0 && checkedCount < this.jxcstoreData.length;
      },
      printBar() {
        this.$refs.printbarcode.show();
      },
      //唯一码查询
      codeselect() {
        this.$refs.UniqueCode.show()
      },
      excelStoreSale() {
        frameStore({cangkucode: "", categorycode: this.guids, accdate: this.getHalfYearAgoDate()}).then(response => {
          var exdata = response.data.obj;
          let header1 = ["商品编码", "商品名称", "品牌","商品备注", "型号", "色号", "当前库存", "销量", "最近一次销售日期"]
          let column1 = ["seedcode", "seedname", "categoryname","notes", "m", "c", "storenum", "salnum", "maxdate"];
          for (let i in exdata) {
            try {
              var packsize = JSON.parse(exdata[i].packagesize);
              exdata[i].m = packsize.M;
              exdata[i].c = packsize.C;
            } catch (ex) {

            }
          }
          var name = new Date();
          name = "近半年销量" + this.fmtDate(name);
          this.$exportExcel(header1, column1, exdata, name)
        });
      },
      getHalfYearAgoDate() {
    const now = new Date();
    const halfYearAgo = new Date(now);

    // 获取半年前的日期
    halfYearAgo.setMonth(now.getMonth() - 6);

    // 处理跨年边界情况
    if (halfYearAgo.getMonth() > now.getMonth()) {
      halfYearAgo.setFullYear(now.getFullYear() - 1);
    }

    // 格式化为 yyyy-MM-dd
    const year = halfYearAgo.getFullYear();
    const month = String(halfYearAgo.getMonth() + 1).padStart(2, '0');
    const day = String(halfYearAgo.getDate()).padStart(2, '0');

    return `${year}-${month}-${day}`;
  },
      //导出excel
      excelPort() {
        let header1 = []
        let column1 = [];
        for (let i in this.column) {
          header1.push(this.column[i].name);
          column1.push(this.column[i].value);
        }
        var name = new Date();
        name = "库存" + this.fmtDate(name);
        this.$exportExcel(header1, column1, this.tableData, name)
      },
      getCangkuName(cangkucode) {
        for (let i = 0; i < this.jxcstoreData.length; i++) {
          if (cangkucode == this.jxcstoreData[i].cangkucode) {
            return this.jxcstoreData[i].cangkuname.replace('仓库','');
            break
          }
        }
        return '';
      },
      //汇总
      getSummaries(param) {
        const {columns, data} = param;
        const sums = [];
        columns.forEach((column, index) => {
          if (index === 0) {
            sums[index] = '合计';
            return;
          }
          var values = [];
          data.map(function (item) {
            if (column.property != 'model' && column.property != 'color' && column.property != 'costprice')
              values.push(Number(item[column.property]));
          });
          if (!values.every(value => isNaN(value))) {
            sums[index] = values.reduce((prev, curr) => {
              const value = Number(curr);
              if (!isNaN(value)) {
                return prev + curr;
              } else {
                return prev;
              }
            }, 0);
          } else {
            sums[index] = '';
          }
        });

        return sums;
      },
      //时间格式化
      fmtDate(obj) {
        var date = new Date(obj);
        var y = 1900 + date.getYear();
        var m = "0" + (date.getMonth() + 1);
        var d = "0" + date.getDate();
        return y + m.substring(m.length - 2, m.length) + d.substring(d.length - 2, d.length);
      },
      tableRowClassName({row, rowIndex}) {
        if (row.cangkucode === 'all') {
          return 'warning-row';
        }
        return '';
      },
      handleEdit(index, row) {//查看页面
        if (this.showCat) {
          this.$refs.StorageFrameDetail1.initParam({
            jxcstoreData: this.jxcstoreData,
            guids: row.categorycode,
            checkedCangkus: this.checkedCangkus,
            minyear: this.minyear,
            minmonth: this.minmonth
          });
        } else {
          row.cangkucode=this.checkedCangkus[0];
          row.cangkuname=this.getCangkuName(row.cangkucode);
          row.categorycode=this.guids
          this.$refs.DataContactView.initData(row, this.minyear, this.minmonth, this.minyear, this.minmonth);
        }
      },
      handleTransfer(index, item) {//调拨页面
        this.$refs.DataContactEdit2.show()
        this.$refs.DataContactEdit2.initData(item)
      },
      handleBuy(index, item) {//采购页面
        this.$refs.BuyorderDetailEdit.show()
        this.$refs.BuyorderDetailEdit.initData(item)
      },
      //年份
      getYearList() {
        var arr = [];
        var yearnow = new Date().getFullYear();
        for (let i = yearnow; i >= 2022; i--) {
          arr.push(i)
        }
        return arr
      },
      checktree1(guids, names, arr) {
        this.guids = guids;
      },
      //具体商品选择 根据前台数据筛选
      checktree(guids, names, arr) {
        this.seedcode = guids;
        this.seedname = names
      },

      //商品类别
      bindTreeData() {//绑定分类树
        this.$refs.treeGroupSeed.bindData(() => {
          return getGoodsTree({onlyShowGroupType: true, onlyShowEnabledGroupType: true,categorystarts:'002;003;004;005;006'});
        })
      },
      //商品
      bindData() {
        this.$refs.treeSeed.bindData(() => {
          return getGoodsTree({nostock: 1})
        })

      },
      afterBindTree(result) {
        //if (result.length > 0 && result[0].hasChildren && result[0].children[0].hasChildren) {//有3层分类（找眼镜网产品过多，只能分类别查）
          this.$refs.treeGroupSeed.handleNodeClick(result[0]);
        //}
        this.userInfoModel = JSON.parse(localStorage.getItem("hpapi_userInfoModel"))
        getListDataall().then(response => {
          this.jxcstoreData = response.data.obj
          for(let i in this.jxcstoreData) {
            this.allOptions.push(this.jxcstoreData[i].cangkucode)
          }
          this.afterSearch = false;
          if(this.jxcstoreData.length<=2){//选中最后一个，并开始绑定
            this.checkedCangkus=[this.jxcstoreData[this.jxcstoreData.length-1].cangkucode];
            this.bindGrid();
          }
        })
      },
      initParam(param) {
        this.guids = param.guids;
        this.checkedCangkus = param.checkedCangkus;
        this.minyear = param.minyear;
        this.minmonth = param.minmonth;
        this.bindGrid();
      },
      findglassFrame(){
        this.$refs.Findframe1.show();
      },
      bindGrid() {//绑定列表
        var cangkucodes='';
        if(this.checkedCangkus.length==0){
          this.$message({
            message: '请先选择仓库！',
            type: 'error'
          })
          return;
        }
        this.afterSearch = true;
        this.tableData = []
        this.oldtableData = []
        for(let i in this.checkedCangkus){
          cangkucodes+=this.checkedCangkus[i]+';';
        }
        this.column=[];
        getFramelistwithstore({
          searchdata: '',//产品名称（保留 暂不考虑）
          categorycode: this.guids,//产品分类（单选）
          cangkucode: cangkucodes,//选择的仓库（多选）
          seedcode: '',
          minyear: this.minyear,
          minmonth: this.minmonth,
          maxyear: this.minyear,
          maxmonth: this.minmonth,
          nostock: 1,
        }).then(response => {
          this.eltableheight = this.tableHeight(this.cannotedit?8:90);

          this.oldtableData = response.data.obj
          this.showCat = this.guids.length < 9;
          if (this.showCat) {//按品牌显示
            this.search.model=''
            this.search.color=''
            this.search.seedname=''
            this.column.push({name: '品牌名称', value: 'categoryname', width: '100px', align: 'left'})
          } else {//按产品显示
            this.search.categoryname=''
            this.column.push({name: '商品编码', value: 'seedcode', width: '80px', align: 'left'})
            this.column.push({name: '商品名称', value: 'seedname', width: '150px', align: 'left'})
            this.column.push({name: '型号', value: 'model', width: '80px', align: 'left'})
            this.column.push({name: '规格', value: 'color', width: '80px', align: 'left'})
            this.column.push({name: '零售价', value: 'costprice', width: '80px', align: 'right'})
          }
          var moreCangku = this.checkedCangkus.length > 1;
          if (!moreCangku) {//只有一个仓库
            this.column.push({name: '期初', value: 'openbalnum', width: '100px', align: 'right'});
            this.column.push({name: '入库', value: 'debitnum', width: '100px', align: 'right'});
            this.column.push({name: '出库', value: 'creditnum', width: '100px', align: 'right'});
            this.column.push({
              name: this.getCangkuName(this.checkedCangkus[0]),
              value: this.checkedCangkus[0],
              width: '140px',
              align: 'right'
            });
            this.column.push({name: '待出库', value: 'deliverying', width: '100px', align: 'right'});
            this.column.push({name: '实际可用', value: 'canuse', width: '100px', align: 'right'});
            this.column.push({name: '调拨中', value: 'transfernum', width: '100px', align: 'right'});
          } else {//有多个仓库
            for (let i in this.checkedCangkus) {
              this.column.push({
                name: this.getCangkuName(this.checkedCangkus[i]),
                value: this.checkedCangkus[i],
                width: '100px',
                align: 'right'
              });
            }
            this.column.push({name: '合计', value: 'sum', width: '100px', align: 'right'});
          }

          for (let i in this.oldtableData) {
            var row = this.oldtableData[i];
            if (row.packagesize == null)
              row.packagesize = '';
            row.model = '';
            row.color = '';
            if (row.packagesize) {
              var pg = JSON.parse(row.packagesize);
              row.model = pg.M;
              row.color = pg.C;
            }

            if (moreCangku) {//多仓库的时候需要合并
              var sum=row.openbalnum + row.debitnum - row.creditnum -(row.deliverying?row.deliverying:0);// + (row.transfernum?row.transfernum:0)
              row[row.cangkucode] = sum;
              row.sum = sum;

              var hasValue = false;
              if (this.showCat) {
                for (let j in this.tableData) {
                  if (this.tableData[j].categorycode.toString() == row.categorycode.toString()) {
                    hasValue = true;
                    if(!this.tableData[j][row.cangkucode]) this.tableData[j][row.cangkucode]=0;
                    this.tableData[j][row.cangkucode] += sum;
                    this.tableData[j].sum += sum;
                    break;
                  }
                }
              } else {
                for (let j in this.tableData) {
                  if (this.tableData[j].seedcode == row.seedcode && this.tableData[j].packagesize == row.packagesize) {
                    hasValue = true;
                    if(!this.tableData[j][row.cangkucode]) this.tableData[j][row.cangkucode]=0;
                    this.tableData[j][row.cangkucode] += sum;
                    this.tableData[j].sum += sum;
                    break;
                  }
                }
              }
              if (!hasValue)
                this.tableData.push(row)
            } else {
              var sum = row.openbalnum + row.debitnum - row.creditnum ;
              row[row.cangkucode] = sum;
              row['canuse'] =sum  -row.deliverying;;
              row.sum = sum;
              this.tableData.push(row)
            }
          }

          if(!this.showCat) {
            this.tableData.sort(function (a, b) {
              if (a.model == b.model)
                return a.color.localeCompare(b.color)
              else
                return a.model.localeCompare(b.model)
            })
          }
        }).catch((error) => {
          console.log(error)
        });
      },
    },

    mounted() {
      this.bimanage=this.$route.query.bimanage?true:false;
      this.islaox=isLaoxian()||isXiaoTuan();
      this.isXiaoT=isXiaoTuan();
    },
    components: {
      StorageFrameView,
      Storeprintbarcode,
      BuyorderDetailEdit,
      AllocationEditNew,
      UniqueCode,
      StorageFrameDetail,
      Findframe
    }
  }
</script>

<style>
  .el-table .warning-row {
    background: oldlace;
  }
</style>



// WEBPACK FOOTER //
// src/components/testorder/warehouse/StorageFrame.vue